import { TwoSellarCreditCheckDialogContent } from "./TwoSellarCreditCheckDialogContent/TwoSellarCreditCheckDialogContent";

export const SellarCreditCheckDialogContent = ({
  onDismiss,
}: {
  onDismiss: () => void;
}) => {
  return <TwoSellarCreditCheckDialogContent onDismiss={onDismiss} />;
};
